<template>
    <div>
        <modal-dialog :show="show" @close="close">
            <h2>WE ARE NOW OPEN &amp; ACCEPTING ORDERS!</h2>
            <p>Whilst we will do everything we can to get your orders to you as soon as possible, we cannot guarantee our usual next day service but we will endeavour to ensure that you receive all deliveries within <strong>48/72</strong> hours from receipt of order. Given the current health crisis and government guidance, we are sure you will understand this.</p>
            <p><strong>Our trade counter desk is open for pre-arranged collection orders only from 7:30am – 5:00pm.</strong></p>
            <p><strong>However, walk in customers are not yet permitted due to social distancing guidelines and limitations.</strong></p>
        </modal-dialog>
    </div>
</template>

<script>
    import ModalDialog from './Elements/ModalDialog.vue';
    export default {
        components: {
            ModalDialog
        },
        data () {
            return {
                show: true
            }
        },
        methods: {
            close () {
                createCookie('reopened_modal', true, 120); // Remember for two hours
                this.show = false;
            }
        },
        mounted () {
            if (getCookie('reopened_modal')) {
                this.show = false;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/CoronaMessage.vue